import { Stack, StackProps } from "@mui/material"
import { animated, AnimationConfig, useTrail } from "@react-spring/web"
import React, { Children } from "react"

import { isServer, SPRING_CONFIGS } from "../utils/utils"

export type StaggeredListProps = StackProps & {
  config?: Partial<AnimationConfig>
  delay?: number
  secondary?: boolean
  show?: boolean
  tertiary?: boolean
}

const SHOW_STATE = { opacity: 1, y: 0 }
const HIDE_STATE = { opacity: 0, y: 60 }
const INIT_STATE = { opacity: 0, y: 60 }

const SEC_SHOW_STATE = { opacity: 1, x: 0 }
const SEC_HIDE_STATE = { opacity: 0, x: -45 }
const SEC_INIT_STATE = { opacity: 0, x: -45 }

const TER_SHOW_STATE = { opacity: 1, y: 0 }
const TER_HIDE_STATE = { opacity: 0, y: -15 }
const TER_INIT_STATE = { opacity: 0, y: -15 }

export function StaggeredList(props: StaggeredListProps) {
  const {
    children,
    show = true,
    config,
    secondary = false,
    tertiary = false,
    delay,
    ...rest
  } = props
  const hideState = tertiary ? TER_HIDE_STATE : secondary ? SEC_HIDE_STATE : HIDE_STATE
  const showState = tertiary ? TER_SHOW_STATE : secondary ? SEC_SHOW_STATE : SHOW_STATE
  const initState = tertiary ? TER_INIT_STATE : secondary ? SEC_INIT_STATE : INIT_STATE

  const from = isServer ? showState : show ? initState : hideState
  const to = isServer ? showState : show ? showState : hideState

  const items = Children.toArray(children)
  const trails = useTrail(items.length, {
    config: config || (show ? SPRING_CONFIGS.quicker : SPRING_CONFIGS.veryQuick),
    delay,
    from,
    reverse: !show,
    to,
  })

  return (
    <Stack {...rest}>
      {trails.map((style, index) => (
        <animated.div key={index} style={style}>
          {items[index]}
        </animated.div>
      ))}
    </Stack>
  )
}
